<template>
    <b-modal v-model="show" title="ЧЕГАРАДОШ ТУМАНЛАР" size="lg" class="region-borders-setting" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid pl-0 pr-0" style="min-height: 500px;">
            <div class="row">
                <div class="col-md-6 form-content mt-0">
                    <label>АСОСИЙ ХУДУД</label>
                    <div class="form-group">
                        <label>Вилоятни танланг</label>
                        <v-select
                          label="label"
                          v-model="dictionaryData.data.province"
                          :filterable="false"
                          :options="provinces"
                          @search="onProvinceSearch"
                        >
                         <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label>Туманни танланг</label>
                        <v-select
                            label="label"
                            :options="regions"
                            v-model="dictionaryData.data.region"
                            :filterable="false"
                            @search="onRegionSearch"
                            @search:focus="onRegionFocus"
                            @change="onChangeRegion"
                        >
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                </div>
                <div class="col-md-6 form-content">
                    <label>ЧЕГАРАДОШ ХУДУДЛАР</label>
                    <div class="form-group">
                        <label>Чегарадош туманлар</label>
                        <tree-select
                                class="form-control"
                                placeholder="Танланг..."
                                :multiple="true"
                                :options="regions2"
                                v-model="dictionaryData.data.borderRegions"
                                :noOptionsText="treeEmptyOptionText"
                        ></tree-select>
                    </div>
                </div>
            </div>
        </div>
        <template slot="modal-footer">
            <div class="w-100">
                <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_REGION_BORDER_ADD')" @click="save">{{$t("action.save")}}</button>
                <button class="all-btn delete-btn float-right mr-2" @click="close">{{$t("action.cancel")}}</button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import TreeSelect from '@riophae/vue-treeselect';
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            TreeSelect,
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
       data() {
           return {
             show: false,
             processing: false,
             filterProvince: initFilterModel(),
             filterRegion: initFilterModel(),
             provinces: [],
             region: {},
             province: {},
             regions: [],
             regions2: [],
             dictionaryData: this.initData()
           }
       },
       computed: {
           treeEmptyOptionText() {
              return this.$t("messages.combo.empty")
           }
       },
       methods: {
           initData() {
              return {
                  id: null,
                  dictionaryType: 'REGION_BORDERS_SETTING',
                  data: {
                      province: null,
                      region: null,
                      borderRegions: []
                  }
              }
           },
           init() {
               this.provinces = [];
               this.filterProvince.search = '';
               this.$http.post('/province/list', this.filterProvince)
                   .then(res => {
                       this.provinces = this.getAsMaps(res.data);
                   }, err => {
                       console.log(err);
                   });
           },
           getAsMaps(result) {
               if (result && result.data && result.data.length > 0) {
                   return result.data.map(d =>({id: d.id, label: d.name}))
               }
               return [];
           },
           save() {
             const vm = this;
             this.processing = true;
             this.$http.post('dictionary/save',this.dictionaryData)
                 .then(res => {
                     const response = res.data;
                     if (response.status === 'SUCCESS') {
                         vm.show = false;
                         this.$emit('change')
                     }
                     vm.processing = false;
                 },err => {
                   vm.processing = false;
                   console.log(err);
               });
           },
           close() {
              this.show = false;
           },
           onProvinceSearch(searchTxt, loading) {
               loading(true);
               this.provinces = [];
               this.filterProvince.search = searchTxt;
               this.$http.post('/province/list', this.filterProvince)
                   .then(res => {
                       this.provinces = this.getAsMaps(res.data);
                       loading(false);
                   }, err => {
                       console.log(err);
                   });
           },
           onRegionSearch(searchTxt, loading) {
               loading(true);
               this.regions = [];
               this.filterRegion.search = searchTxt;
               this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
               this.$http.post('/region/search', this.filterRegion)
                   .then(res => {
                       this.regions = this.getAsMaps(res.data);
                       loading(false);
                   }, err => {
                       console.log(err);
                   });
           },
           onRegionFocus() {
               this.regions = [];
               this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
               this.$http.post('/region/search', this.filterRegion)
                   .then(res => {
                       this.regions = this.getAsMaps(res.data);
                   }, err => {
                       console.log(err);
                   });
           },
           onChangeRegion() {
               this.regions2 = [];
               if (this.dictionaryData.data.region && this.dictionaryData.data.region.id &&
                   this.dictionaryData.data.region.id > 0) {
                   this.regions2 = this.regions.filter(region => region.id !== this.dictionaryData.data.region.id);
               }
           },
           initBorderRegion() {
               if (this.dictionaryData.data.province && this.dictionaryData.data.province.id > 0) {
                   this.regions = [];
                   this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
                   this.$http.post('/region/search', this.filterRegion)
                       .then(res => {
                           this.regions = this.getAsMaps(res.data);
                           this.onChangeRegion();
                       }, err => {
                           console.log(err);
                       });
               }
           }
       },
       created() {
           this.filterProvince.page.size = 1000;
           this.filterRegion.page.size = 1000;

           this.init();
           this.$eventBus.$on("showRegionBordersSettingsModal", (data) => {
               if (data) {
                   this.dictionaryData = clone(data);
                   this.initBorderRegion();
               } else {
                   this.regions = [];
                   this.regions2 = [];
                   this.dictionaryData = this.initData();
               }
               this.show = true;
           });
       }
    }
</script>

<style>
    .region-borders-setting .modal-dialog {
        max-width: 800px;
        width: 800px !important;
    }
    .region-borders-setting .modal-content {
        width: 800px !important;
    }
    .form-content {
        border: #E5E7E9 solid 1px;
        background: #F2F3F4;
    }
</style>